export default {
      id: "child_friendly-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.845ff42f.svg#child_friendly",
      toString: function () {
        return this.url;
      }
    }